



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AlertStoreActions, AlertType } from '@/ui/stores/AlertStore';
import type { User } from '@/core/admin/models/User';
import { deleteCmsCredentialUseCase } from '@/core/admin/usecases/cmsCredentialUseCases';

@Component({
  name: 'DeleteCmsCredentialsDialog',
})
export default class DeleteCmsCredentialsDialog extends Vue {
  @Prop({ required: true }) customerId!: string;
  @Prop({ required: true }) currentUser!: User;
  @Prop({ required: true }) showDialog!: boolean;

  private isLoading = false;

  async deleteCmsCredential() {
    if (this.customerId) {
      this.isLoading = true;
      deleteCmsCredentialUseCase(this.currentUser, this.customerId)
        .then(() => {
          this.closeDialog();
          this.$store.dispatch(AlertStoreActions.TRIGGER_ALERT, {
            message: 'Admin.cms-credentials.delete-success',
            type: AlertType.SUCCESS,
          });
          this.$emit('deleted');
        })
        .catch(() => {
          this.$store.dispatch(AlertStoreActions.TRIGGER_ALERT, {
            message: 'Admin.cms-credentials.delete-failure',
            type: AlertType.ERROR,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  closeDialog() {
    this.$emit('close');
  }
}
